import React from 'react';
import { SupportTopic } from '../messages.types';
import DopingIcon from '../../../assets/images/doping-icon.png';
import clsx from 'clsx';
import MessagesPlaceholder from '@/assets/svg/messages-placeholder.svg';
import { useSizes } from '@/utility/responsive.ts';

interface TopicListProps {
	topics: SupportTopic[];
	onSelectTopic: (topic: SupportTopic) => void;
	onNewTopic?: () => void;
	fetchNextData?: () => void;
	hasNextPage?: boolean;
	isLoading?: boolean;
	currentUser: {
		id?: number | string;
		name?: string;
		subTitle?: string;
		avatar?: string;
	} | null;
	showHeader?: boolean;
	onGoBack?: () => void;
	showFilter?: boolean;
	hasRelatedStudent?: boolean;
	onFilterChange?: (hasRelatedStudent: boolean) => void;
}

const TECHNICAL = 'Teknik Destek';

const TopicListNormal: React.FC<TopicListProps> = ({ topics, onSelectTopic, onNewTopic, currentUser, fetchNextData, hasNextPage, isLoading, showHeader = true, onGoBack, showFilter, hasRelatedStudent, onFilterChange }) => {
	const { isMobile } = useSizes();

	return (
		<div className="topic-content">
			{showHeader && (
				<div className="new-topic">
					{isMobile && (
						<button
							className="back-button"
							onClick={onGoBack}>
							<i className="icons-arrow-left"></i>
						</button>
					)}

					<div className="topic-icon">
						<img
							src={currentUser?.avatar || DopingIcon}
							alt="Doping Hafıza"
						/>
					</div>

					<div className="topic-info">
						<div className="topic-title">{currentUser?.name}</div>
						<div className="topic-description">{currentUser?.subTitle}</div>
					</div>

					<button
						className="new-topic-button"
						onClick={onNewTopic}>
						<i className="icons-add-circle"></i>
						{currentUser?.subTitle?.includes(TECHNICAL) ? 'Yeni Konu' : 'Yeni Mesaj'}
					</button>
				</div>
			)}
			{showFilter && (
				<div className="topic-filter">
					<button
						className={clsx('filter-button', { active: !hasRelatedStudent })}
						onClick={() => onFilterChange?.(false)}>
						Uzman Destek
					</button>
					<button
						className={clsx('filter-button', { active: hasRelatedStudent })}
						onClick={() => onFilterChange?.(true)}>
						Öğrenci Destek Talepleri
					</button>
				</div>
			)}
			{topics?.length ? (
				<div className="topic-list">
					{topics.map((topic, index) => (
						<div
							key={topic.id + index.toString()}
							className="topic-item"
							onClick={() => onSelectTopic(topic)}>
							<div className="topic-icon">
								<img
									src={DopingIcon}
									alt="Doping Hafıza"
								/>
							</div>

							<div
								className={clsx('topic-info', {
									'is-read': topic.isRead === true
								})}>
								<div className="topic-title">{topic.title}</div>
								{!isMobile && <div className="topic-description">{topic.description}</div>}
							</div>

							<div
								className={clsx('topic-date', {
									'is-read': topic.isRead === true
								})}>
								{topic.date}
							</div>
						</div>
					))}
					{hasNextPage && (
						<div className="load-more-container">
							<button
								className="load-more-button"
								onClick={fetchNextData}
								disabled={isLoading}>
								Daha Fazla Yükle
							</button>
						</div>
					)}
				</div>
			) : (
				<div className="content placeholder">
					<img
						src={MessagesPlaceholder}
						alt="messages-placeholder"
					/>
					<p>Henüz bir mesajınız bulunmamaktadır!</p>
					<span>Talep oluşturmak için "Yeni Konu" butonunu kullanın.</span>
				</div>
			)}
		</div>
	);
};

export default TopicListNormal;
